import React from 'react';
import ReactExport from 'react-data-export';
import { intlShape, injectIntl } from 'react-intl';

import Fab from '@material-ui/core/Fab';
import { DownloadIcon } from '../../../../images/icons/WrapSvg';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class Download extends React.Component {
    render() {
        const { intl, info, parameters } = this.props;
        return (
            <ExcelFile
                element={
                    <Fab
                        color="primary"
                        aria-label="add"
                        className={'button_float'}
                        onClick={this.handleClick}
                    >
                        <DownloadIcon />
                    </Fab>
                }
            >
                <ExcelSheet data={parameters} name={intl.formatMessage({ id: 'parameters' })}>
                    <ExcelColumn label={intl.formatMessage({ id: 'family' })} value="family" />
                    <ExcelColumn label={intl.formatMessage({ id: 'process' })} value="process" />
                    <ExcelColumn label={intl.formatMessage({ id: 'field' })} value="field" />
                    <ExcelColumn label={intl.formatMessage({ id: 'value' })} value="value" />
                    <ExcelColumn label={intl.formatMessage({ id: 'local' })} value="local" />
                    <ExcelColumn
                        label={intl.formatMessage({ id: 'form_field_add_date_init_label' })}
                        value="from"
                    />
                    <ExcelColumn
                        label={intl.formatMessage({ id: 'form_field_add_date_end_label' })}
                        value="to"
                    />
                </ExcelSheet>
                <ExcelSheet data={info} name={intl.formatMessage({ id: 'report_search_values' })}>
                    <ExcelColumn label={intl.formatMessage({ id: 'date' })} value="creado" />
                    <ExcelColumn label={intl.formatMessage({ id: 'filled' })} value="cierretarea" />
                    <ExcelColumn label={intl.formatMessage({ id: 'instance' })} value="instancia" />
                    <ExcelColumn label={intl.formatMessage({ id: 'user' })} value="usuario" />
                    <ExcelColumn label={intl.formatMessage({ id: 'local' })} value="nlocal" />
                    <ExcelColumn label={intl.formatMessage({ id: 'value' })} value="valor" />
                    <ExcelColumn
                        label={intl.formatMessage({ id: 'outofperiod' })}
                        value="vencido"
                    />
                </ExcelSheet>
            </ExcelFile>
        );
    }
}
Download.propTypes = {
    intl: intlShape.isRequired,
};

Download = injectIntl(Download);

export default Download;



// WEBPACK FOOTER //
// ./src/components/complex/reports/search/Download.js